import React, { useEffect } from 'react';

interface QualityAnalysisSectionProps {
  formData: {
    nbSacsDeclares: number;
    nbSacsSains: number;
    nbSacsRecond: number;
    nbSacsHumides: number;
    nbSacsDechires: number;
    nbSacsRejetes: number;
    nbSacsAcceptes: number;
    poidsAcceptes: number;
    observations: string;
  };
  onInputChange: (field: string, value: any) => void;
  conditionnementCapacite?: number; // Capacité du conditionnement en kg
}

const QualityAnalysisSection: React.FC<QualityAnalysisSectionProps> = ({ 
  formData, 
  onInputChange, 
  conditionnementCapacite = 1 // Valeur par défaut de 1 kg
}) => {
  const FACTEUR_RECONDITIONNEMENT = 4;

  // Calcul automatique du nombre de sacs acceptés
  useEffect(() => {
    const nbSacsAcceptesCalcules = (formData.nbSacsSains || 0) + (formData.nbSacsRecond || 0);
    if (formData.nbSacsAcceptes !== nbSacsAcceptesCalcules) {
      onInputChange('nbSacsAcceptes', nbSacsAcceptesCalcules);
    }
  }, [formData.nbSacsSains, formData.nbSacsRecond, onInputChange]); // Retiré formData.nbSacsAcceptes des dépendances

  // Calcul automatique du poids accepté
  useEffect(() => {
    const poidsAcceptesCalcules = ((formData.nbSacsSains || 0) + ((formData.nbSacsRecond || 0) * FACTEUR_RECONDITIONNEMENT)) * conditionnementCapacite;
    if (formData.poidsAcceptes !== poidsAcceptesCalcules) {
      onInputChange('poidsAcceptes', poidsAcceptesCalcules);
    }
  }, [formData.nbSacsSains, formData.nbSacsRecond, conditionnementCapacite, onInputChange]); // Retiré formData.poidsAcceptes des dépendances
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Détails des Sacs
        </h3>
        <p className="text-sm text-gray-600">
          Saisissez les informations détaillées sur les sacs.
        </p>
      </div>
      
      <div className="space-y-6">
        <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nb de sacs déclarés</label>
          <input
            type="number"
            value={formData.nbSacsDeclares || 0}
            onChange={(e) => {
              console.log(`📝 Nb de sacs déclarés: ${e.target.value}`);
              onInputChange('nbSacsDeclares', parseInt(e.target.value) || 0);
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            placeholder="0"
            min="0"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nb de sacs sains</label>
          <input
            type="number"
            value={formData.nbSacsSains || 0}
            onChange={(e) => onInputChange('nbSacsSains', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            placeholder="0"
            min="0"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nb de sacs Recond</label>
          <input
            type="number"
            value={formData.nbSacsRecond || 0}
            onChange={(e) => onInputChange('nbSacsRecond', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            placeholder="0"
            min="0"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nb de sacs Humides</label>
          <input
            type="number"
            value={formData.nbSacsHumides || 0}
            onChange={(e) => onInputChange('nbSacsHumides', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            placeholder="0"
            min="0"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nb de sacs déchirés</label>
          <input
            type="number"
            value={formData.nbSacsDechires || 0}
            onChange={(e) => onInputChange('nbSacsDechires', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            placeholder="0"
            min="0"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nb de sacs rejetés</label>
          <input
            type="number"
            value={formData.nbSacsRejetes || 0}
            onChange={(e) => onInputChange('nbSacsRejetes', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            placeholder="0"
            min="0"
          />
        </div>
                 <div>
           <label className="block text-sm font-medium text-gray-700 mb-1">
             Nb de sacs acceptés 
             <span className="text-xs text-gray-500 ml-1">(calculé automatiquement)</span>
           </label>
           <input
             type="number"
             value={formData.nbSacsAcceptes || 0}
             readOnly
             className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
             placeholder="0"
           />
           <p className="text-xs text-gray-500 mt-1">
             = {formData.nbSacsSains || 0} sains + {formData.nbSacsRecond || 0} recond 
           </p>
         </div>
         <div>
           <label className="block text-sm font-medium text-gray-700 mb-1">
             Poids accepté (kg)
             <span className="text-xs text-gray-500 ml-1">(calculé automatiquement)</span>
           </label>
           <input
             type="number"
             value={formData.poidsAcceptes || 0}
             readOnly
             className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
             placeholder="0"
           />
           <p className="text-xs text-gray-500 mt-1">
           = ({formData.nbSacsSains || 0} sains + ({formData.nbSacsRecond || 0} recond × {FACTEUR_RECONDITIONNEMENT})) sacs × {conditionnementCapacite} kg/sac
            
           </p>
         </div>
         </div>
      </div>
    </div>
  );
};

export default QualityAnalysisSection;
